
(function () {
  'use strict';

  var LOOK_PREFIX = '/pages/jewellery-look/';
  var SESSION_KEY = 'gaLookAttributionV1';
  var CHECKOUT_TRACKED_KEY = 'gaLookCheckoutIntentTrackedV3';
  var COOKIE_NAME = 'ga_last_look';
  var COOKIE_TTL_SECONDS = 1800;

  function safeParse(value) {
    try {
      return JSON.parse(value || '{}');
    } catch (error) {
      return {};
    }
  }

  function readState() {
    try {
      var state = safeParse(sessionStorage.getItem(SESSION_KEY));
      var seen = Date.parse(state.lastSeenAt || '');
      var age = Date.now() - seen;

      // A Look is eligible for only 30 minutes after the last Look view.
      if (!Number.isFinite(seen) || age < 0 ||
          age > COOKIE_TTL_SECONDS * 1000) {
        return {};
      }

      return state;
    } catch (error) {
      return {};
    }
  }

  function getLookHandle(pathname) {
    if (!pathname || pathname.indexOf(LOOK_PREFIX) !== 0) return '';
    return decodeURIComponent(pathname.slice(LOOK_PREFIX.length).replace(/\/$/, ''));
  }

  function normaliseTitle(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/\s*[|–—-]\s*Galleria Armadoro.*$/i, '')
      .trim();
  }

  function getLookName(handle) {
    var heading = document.querySelector('[data-ga-look-title], .ga-look-detail h1, main h1');
    var title = heading ? heading.textContent : document.title;
    title = normaliseTitle(title);
    if (title) return title;
    return handle
      .split('-')
      .filter(Boolean)
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  function updateSessionState(handle, name, path) {
    var now = new Date().toISOString();
    var current = readState();
    var history = Array.isArray(current.history) ? current.history.slice() : [];

    history = history.filter(function (entry) {
      return entry && entry.handle !== handle;
    });
    history.push({ handle: handle, name: name, path: path, seenAt: now });
    history = history.slice(-5);

    var state = {
      firstSeenAt: current.firstSeenAt || now,
      lastSeenAt: now,
      firstLookHandle: current.firstLookHandle || handle,
      firstLookName: current.firstLookName || name,
      lastLookHandle: handle,
      lastLookName: name,
      history: history
    };

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
    sessionStorage.removeItem(CHECKOUT_TRACKED_KEY);
    return state;
  }

  function writeCookie(handle) {
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(handle) +
      '; Path=/; Max-Age=' + COOKIE_TTL_SECONDS + '; SameSite=Lax';
  }

  function cartAttributesFromState(state) {
    return {
      '__ga_look_attribution': '1',
      '__ga_look_first': state.firstLookName,
      '__ga_look_first_handle': state.firstLookHandle,
      '__ga_look_last': state.lastLookName,
      '__ga_look_last_handle': state.lastLookHandle,
      '__ga_look_history': state.history.map(function (entry) {
        return entry.handle;
      }).join(' > '),
      '__ga_look_first_seen': state.firstSeenAt,
      '__ga_look_last_seen': state.lastSeenAt
    };
  }

  function persistToCart(state) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: cartAttributesFromState(state) })
    }).catch(function () {});
  }

  function baseEventParams(state) {
    return {
      look_name: state.lastLookName || '',
      look_handle: state.lastLookHandle || '',
      look_first: state.firstLookName || '',
      look_first_handle: state.firstLookHandle || '',
      look_last: state.lastLookName || '',
      look_last_handle: state.lastLookHandle || '',
      look_history: Array.isArray(state.history)
        ? state.history.map(function (entry) { return entry.handle; }).join('|')
        : '',
      attribution_source: 'ga_theme_session'
    };
  }

  function publishAnalytics(eventName, state, extra) {
    if (!state || !state.lastLookHandle) return;

    var params = baseEventParams(state);
    Object.keys(extra || {}).forEach(function (key) {
      params[key] = extra[key];
    });

    window.dataLayer = window.dataLayer || [];
    var layerEvent = { event: eventName };
    Object.keys(params).forEach(function (key) {
      layerEvent['ga_' + key] = params[key];
    });
    window.dataLayer.push(layerEvent);

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  }

  function trackAdd(details) {
    var state = readState();
    if (!state.lastLookHandle) return;
    publishAnalytics('ga_look_add_to_cart', state, details || {});
  }

  function trackCheckout() {
    var state = readState();
    if (!state.lastLookHandle) return;
    if (sessionStorage.getItem(CHECKOUT_TRACKED_KEY) === '1') return;

    sessionStorage.setItem(CHECKOUT_TRACKED_KEY, '1');

    // Clicking checkout is intent, not a verified checkout start.
    publishAnalytics('ga_look_checkout_intent', state, {
      interaction_type: 'checkout_button_click'
    });
  }

  function installCheckoutTracking() {
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('.ga-checkout-btn, #gaMobileCheckoutBtn, [name="checkout"]')
        : null;
      if (target) trackCheckout();
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.closest && form.closest('.ga-summary form')) {
        trackCheckout();
      }
    }, true);
  }

  function initLookPage() {
    var path = window.location.pathname || '';
    var handle = getLookHandle(path);
    if (!handle) return;

    var name = getLookName(handle);
    var state = updateSessionState(handle, name, path);

    writeCookie(handle);
    persistToCart(state);
    publishAnalytics('ga_look_view', state, {});
  }

  window.GALookAttribution = window.GALookAttribution || {};
  window.GALookAttribution.trackAdd = trackAdd;
  window.GALookAttribution.trackCheckout = trackCheckout;
  window.GALookAttribution.getState = readState;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      installCheckoutTracking();
      initLookPage();
    }, { once: true });
  } else {
    installCheckoutTracking();
    initLookPage();
  }
})();
